export const linkStyles = {
  color: '#6b7280',
  fontWeight: 600,
  fontSize: '1rem',
  textDecoration: 'none',
  cursor: 'pointer',
  transition: 'color 0.3s ease',
  '&:hover, &:focus': {
    color: '#111827',
    outline: 'none',
  },
};

export const containerMaxWidth = 1200;

export const pagePadding = {
  pt: '4rem', // 64px
  pb: '5rem', // 80px
};

export const heading1 = {
  fontSize: '3rem', // 48px
  fontWeight: 800,
  color: '#111827',
  letterSpacing: '0.02em',
  lineHeight: 1.2,
  marginTop: 0,
  marginBottom: '0.5rem',
};

export const heading2 = {
  fontSize: '2.25rem', // 36px
  fontWeight: 700,
  color: '#111827',
  letterSpacing: '0.01em',
  lineHeight: 1.3,
  marginTop: 0,
  marginBottom: '0.5rem',
};

export const heading3 = {
  fontSize: '1.875rem', // 30px
  fontWeight: 700,
  color: '#111827',
  letterSpacing: '0.01em',
  lineHeight: 1.3,
  marginTop: 0,
  marginBottom: '0.5rem',
};

export const bodyText = {
  fontSize: '1rem', // 16px
  color: '#6b7280', // cinza neutro
  lineHeight: 1.5,
  marginTop: 0,
  marginBottom: '1rem',
};

export const cardStyles = {
  backgroundColor: '#ffffff',
  borderRadius: '0.75rem', // 12px
  boxShadow: '0 4px 8px rgba(0,0,0,0.05)',
  transition: 'box-shadow 0.3s cubic-bezier(0.4,0,0.2,1)',
  padding: '1.5rem',
  '&:hover, &:focus-within': {
    boxShadow: '0 8px 20px rgba(0,0,0,0.12)',
    outline: 'none',
  },
};

export const buttonPrimaryStyles = {
  borderRadius: '0.75rem',
  px: 6,
  py: 1.5,
  fontWeight: 700,
  fontSize: '1rem',
  textTransform: 'none',
  bgcolor: '#111827',
  color: '#fff',
  '&:hover': {
    bgcolor: '#374151',
    transition: 'background-color 0.3s ease',
  },
};

export const buttonPrimary = {
  borderRadius: '0.75rem',
  px: 6,
  py: 1.5,
  fontWeight: 700,
  fontSize: '1rem',
  textTransform: 'none',
  backgroundColor: '#111827',
  color: '#ffffff',
  cursor: 'pointer',
  transition: 'background-color 0.3s cubic-bezier(0.4,0,0.2,1)',
  '&:hover, &:focus': {
    backgroundColor: '#374151',
    outline: 'none',
  },
};

export const buttonSecondary = {
  borderRadius: '0.75rem',
  px: 5,
  py: 1.25,
  fontWeight: 600,
  fontSize: '1rem',
  textTransform: 'none',
  backgroundColor: '#6b7280',
  color: '#ffffff',
  cursor: 'pointer',
  transition: 'background-color 0.3s ease',
  '&:hover, &:focus': {
    backgroundColor: '#4b5563',
    outline: 'none',
  },
};

export const formInput = {
  width: '100%',
  padding: '0.75rem 1rem',
  borderRadius: '0.75rem',
  border: '1px solid #d1d5db',
  fontSize: '1rem',
  color: '#374151',
  transition: 'border-color 0.3s ease',
  fontFamily: 'inherit',
  '&:focus': {
    borderColor: '#111827',
    boxShadow: '0 0 0 3px rgba(17,24,39,0.2)',
    outline: 'none',
  },
};

export const tableStyles = {
  width: '100%',
  borderCollapse: 'collapse',
  fontSize: '1rem',
  color: '#374151',
  '& th, & td': {
    padding: '0.75rem 1rem',
    textAlign: 'left',
    borderBottom: '1px solid #e5e7eb',
  },
  '& thead th': {
    backgroundColor: '#f9fafb',
    fontWeight: 700,
    color: '#111827',
  },
  '& tbody tr:hover': {
    backgroundColor: '#f3f4f6',
    transition: 'background-color 0.3s ease',
  },
};

export const headerStyles = {
  position: 'sticky',
  top: 0,
  zIndex: 1000,
  backgroundColor: '#ffffff',
  borderBottom: '1px solid #e5e7eb',
  boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '0.75rem 1rem',
  maxWidth: 1200,
  margin: 'auto',
};

export const navLink = {
  fontWeight: 600,
  fontSize: '1rem',
  color: '#6b7280',
  textDecoration: 'none',
  cursor: 'pointer',
  transition: 'color 0.3s ease',
  '&:hover, &:focus': {
    color: '#111827',
    outline: 'none',
  },
};

export const footerStyles = {
  backgroundColor: '#f9fafb',
  padding: '3rem 1rem',
  color: '#6b7280',
  fontSize: '1rem',
  textAlign: 'center',
  borderTop: '1px solid #e5e7eb',
  marginTop: 'auto',
};

export const container = {
  maxWidth: '1200px',
  marginLeft: 'auto',
  marginRight: 'auto',
  paddingLeft: '16px',
  paddingRight: '16px',
};

export const flexCenter = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100vh',
  backgroundColor: '#f3f4f6',
}